import styled from 'styled-components';
import locationIcon from '../../assets/icons/icon-location.svg';
import locationIconWhite from '../../assets/icons/icon-location-white.svg';
import { getRelativeHeight, getRelativeWidth } from '../CardReader/CardReader';

// prettier-ignore
const CurrentZoneIndicator = styled.div`
  display: flex;
  align-items: center;
  font-size: 1em;
  letter-spacing: 0;
  font-weight: 400;
  position: absolute;
  top: ${getRelativeHeight(8)};
  left: 50%;
  transform: translateX(-50%);
  box-sizing: border-box;
  padding-top: 0.5%;
  padding-left: ${getRelativeWidth(19)};
  height: ${getRelativeHeight(19)};
  background-image: url(${(props) => (props.white ? locationIconWhite : locationIcon)});
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: left;
`;

export default CurrentZoneIndicator;
